import { isFunction } from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { useNeedsAttention } from './use-needs-attention';

export const withAttentionBeaconPropsInjection = (WrappedComponent) => {
  const HOC = ({ attentionBeaconProps: attentionBeaconPropsFromProps, ...restProps }) => {
    const [needsAttention, attentionBeaconProps] = useNeedsAttention(attentionBeaconPropsFromProps);
    const { getExtraProps } = attentionBeaconProps;

    const extraProps = useMemo(() => {
      if (isFunction(getExtraProps)) {
        return getExtraProps({ needsAttention, props: restProps });
      }
      return {};
    }, [getExtraProps, needsAttention, restProps]);

    return React.createElement(WrappedComponent, {
      ...restProps,
      ...extraProps,
      attentionBeaconProps,
    });
  };

  HOC.propTypes = {
    attentionBeaconProps: PropTypes.shape({
      getExtraProps: PropTypes.func,
    }),
  };

  HOC.defaultProps = {
    attentionBeaconProps: {
      getExtraProps: undefined,
    },
  };

  hoistNonReactStatics(HOC, WrappedComponent);
  HOC.displayName = `withAttentionBeaconPropsInjection(${getDisplayName(WrappedComponent)})`;
  // HOC.isAttentionBeaconConsumer = true;

  return HOC;
};
